import { gql } from '@apollo/client';

export const LOGIN = gql(/*GraphQL*/ `
  mutation Login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      email
      name
      role
      isVerified
      isGoogleAuth
    }
  }
`);

export const LOGIN_WITH_GOOGLE = gql(/*GraphQL*/ `
  mutation LoginWithGoogle($token: String!) {
    loginWithGoogleAuth(token: $token) {
      email
      name
      role
      isVerified
      isGoogleAuth
    }
  }
`);
